import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import '../App.css';

const plans = {
  premium: { price: 5, days: 30 },
  basic: { price: 2, days: 15 },
};

const Subscribe = () => {
  const [planName, setPlanName] = useState('premium');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    // Fetch user info
    apiFetch('/api/users/me', 'GET').then(res => {
      if (res.success) setUser(res.data);
    }).catch(err => console.warn('User fetch error:', err.message));
  }, []);

  const handleSubscribe = async () => {
    if (!user) {
      alert('Please register or log in to continue.');
      return;
    }

    const plan = plans[planName];

    const payload = {
      planName,
      planPrice: plan.price,
      validityDays: plan.days,
      paymentMethod: 'EcoCash',
      paymentStatus: 'pending',
      phoneNumber,
    };

    setIsSubmitting(true);
    try {
      const response = await apiFetch('/api/subscriptions', 'POST', payload);
      if (response.success) {
        setMessage('🎉 Subscription started! Confirm payment on EcoCash.');
      } else {
        setMessage(response.message || 'Subscription failed.');
      }
    } catch (err) {
      console.error('❌ Subscription error:', err);
      setMessage(err.message || 'Something went wrong.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!user) {
    return (
      <div className="container text-center mt-5">
        <h3 className="text-danger fw-bold">Please Log In or Register</h3>
        <p className="lead">You must be logged in to subscribe.</p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <button className="btn btn-outline-primary" onClick={() => navigate('/login')}>Log In</button>
          <button className="btn btn-primary" onClick={() => navigate('/register')}>Register</button>
        </div>
      </div>
    );
  }

  return (
    <div className="container page-container mt-5">
      <div className="card shadow-lg p-4" style={{ maxWidth: '550px', margin: '0 auto' }}>
        <h2 className="text-center mb-3 text-primary fw-bold">Subscribe to ProTechTion</h2>
        <p className="text-center mb-4 lead">
          Unlock full gadget details and owner info. <strong>Secure your tech for $5/month</strong>.
        </p>

        <div className="form-group mb-3">
          <label className="fw-semibold">Choose Plan</label>
          <select
            className="form-select"
            value={planName}
            onChange={(e) => setPlanName(e.target.value)}
          >
            <option value="premium">Premium – $5 / 30 days</option>
            <option value="basic">Basic – $2 / 15 days</option>
          </select>
        </div>

        <div className="form-group mb-3">
          <label className="fw-semibold">EcoCash Phone Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 0772xxxxxx"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </div>

        <button
          className="btn btn-primary w-100 fw-bold"
          onClick={handleSubscribe}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
        </button>

        {message && (
          <div className="alert alert-info mt-3 text-center" role="alert">
            {message}
          </div>
        )}

        <div className="text-center mt-4">
          <a href="/" className="btn btn-outline-secondary">
            ← Back to Homepage
          </a>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;

